export const ADD_ESANCHIT_SUPPORTING_DOC = "account/esanchit/";
export const UPDATE_ESANCHIT_SUPPORTING_DOC = "account/esanchit/";
export const GET_ESANCHIT_SUPPORTING_DOC = "account/esanchit/timePeriod/";
export const DELETE_ESANCHIT_SUPPORTING_DOC = "account/esanchit/";
